import angular from 'angular';

let module = angular.module('Cartonomy.Shared', ['ngResource']);

module.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
}]);

export default module;


// WEBPACK FOOTER //
// ./src/modules/shared/module.js